import { useState } from 'react';   
import './Pdgtojpeg.css';
import { pdfjs } from 'react-pdf';
import Loader from '../../Utils/Loader.js';
import SharePage from '../SharePage.js';
// import * as pdfjsLib from 'pdfjs-dist'; 
  
 
  
let Pdgtojpeg =()=>{
    pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.mjs`;
    let [loader, setloader]= useState('');
     
     
    const handleFileChangeee = (e) => {
      if(e.target.files[0] !=""){
        document.querySelector(".subcontuploadpdf").style.display = "none";
      }
        const file = e.target.files[0];
        if (file && file.type === 'application/pdf'){
            convertPdfToImages(file);
        }
       
    };

  const [images, setImages] = useState([]);
   
   
  const convertPdfToImages = async (file) => {
    
    setloader("Please Wait Your Pdf File is Loading...")
    document.querySelector(".loading").style.display="block";  
    
    
    const imagesList = [];
    
    // Read the file data
    const data = await new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.readAsArrayBuffer(file);
    });
   

    // Load the PDF document
    const pdf = await pdfjs.getDocument({data}).promise;
  
    // Loop through each page
    for (let i = 1; i <= pdf.numPages; i++) {
      const page = await pdf.getPage(i);
      
      const viewport = page.getViewport({ scale: 1.5 }); // Adjust scale for resolution
      const canvas = document.createElement('canvas');
      const context = canvas.getContext('2d');
      
      canvas.height = viewport.height;
      canvas.width = viewport.width;

      // Render the page on the canvas
      await page.render({
        canvasContext: context,
        viewport: viewport
      }).promise;

      // Convert the canvas to a data URL (JPG format)
      const imgDataUrl = canvas.toDataURL('image/jpeg', 0.8); // 0.8 is the quality
      imagesList.push(imgDataUrl);
        
      
    }
    setImages(imagesList);
    
    document.querySelector(".imageshowcont").style.display="block";
   setloader("")
    document.querySelector(".loading").style.display="none";

  };
  let downloadimagefunction=()=>{
  let parent = document.getElementById("hello");
    let elm = document.createElement("a");
    let pos = parent.firstElementChild.nextElementSibling;
    parent.insertBefore(elm, pos);
    elm.href = images[increaser];
    elm.download = 'image.jpg';
    elm.click();

    document.querySelector(".sharecont").style.display="block";
    document.querySelector(".imageshowcont").style.display="none";

  }



  let [increaser, setincreaser]= useState(0);
  let previousimagefunction=()=>{
    if(increaser != 0){
        increaser--;
       setincreaser(increaser);
       
       
    }else{
        setincreaser(images.length-1);
    }
    if(images.length-1 == 0){
        alert("Pdf has only one page");
    }
     
  }
  let nextimagefunction=()=>{
     if(increaser != images.length-1){
        increaser++;
       setincreaser(increaser);
     }else{
        setincreaser(0);
     }

    if(images.length-1 == 0){
        alert("Pdf has only one page");
    }
     
  }
 
  
 
     return(    
        <div className='maincontofpdftojpeg'>
            <p className='pdftojpgheading'>PDF TO JPG CONVERTER</p>
           <p className='loading'><Loader msg={loader}/></p> 

           
           
            <form className='subcontuploadpdf'>
                 <input style={{display:"none"}} id='choose' onChange={handleFileChangeee} type='file'accept="application/pdf"/>
                 <label htmlFor='choose'>Select PDF File+</label>
                 
            </form>
            <div className='sharecont' style={{display:"none"}}>
              <p style={{color:"green", fontSize:"25px"}}>Downlaod successfully</p>
              <SharePage path='/Converter/pdftojpegconvert' title='Check out this awesome pdf to jpg converter tool' description="Convert your pdf into Jpg"/>
            </div>
            <div style={{display:"none"}} className='imageshowcont'>
                <div className='buttoncont'>
                  <button className='perimagebtn' onClick={previousimagefunction}>PREVIOUS</button>
                  <button className='nextimgbtn' onClick={nextimagefunction}>NEXT</button>
                </div>
                <div className='imagecont'>
                  <p style={{textAlign:"center"}}>Page no: {increaser+1}</p>
                  <img alt='photo' className='immg' src={images[increaser]}/>
                </div>
                <div id='hello' className='imagedownloadcont'> 
                  <button title="Downaload Image"  className='imgdownlaodbtn' onClick={downloadimagefunction}>Downloadd</button>
                </div>
            </div>
            
            
        </div> 
    );
}

export default Pdgtojpeg;